"use strict";

/** Animations */
(() => {
	/**
	 * Import wrapper to constrain available imports for security
	 */
	const imp = async (exported) => {
		const motion = await import("motion");
		const lib = await import("./lib.js");
		switch (exported) {
			case "animate":
				const { animate } = motion;
				const { get_type } = lib;
				return (elements, keyframes, options = undefined) =>
					window.matchMedia("(prefers-reduced-motion: reduce)").matches && options !== undefined
						? (() => {
								const new_options = structuredClone(options);
								for (const key in new_options) {
									if (Object.hasOwnProperty.call(new_options, key)) {
										const element = new_options[key];
										if (get_type(element) === "Object") {
											new_options[key].duration = 0;
											new_options[key].easing = "linear";
										}
									}
								}
								new_options.duration = 0;
								new_options.easing = "linear";
								return animate(elements, keyframes, new_options);
						  })()
						: animate(elements, keyframes, options);
			case "inView":
				const { inView } = motion;
				return inView;
			default:
				return null;
		}
	};

	const init_animations = (attribute) => {
		const go = (element) => {
			const callback = element.dataset[`${attribute}`];
			if (callback) {
				const detect_unsafe = /\b(document|eval|import|self|window)/;
				if (!detect_unsafe.test(callback)) {
					const ancestor_matches = ({ ancestor, matches, on_match }) => {
						const ancestor_element = element.closest(ancestor);
						if (ancestor_element) {
							new MutationObserver((mutations) =>
								mutations.forEach(() => {
									if (ancestor_element.matches(matches)) {
										on_match();
									}
								})
							).observe(ancestor_element, { attributes: true });
						}
					};
					Function(
						"args",
						`"use strict"; const { ancestor_matches, element, imp } = args; (${callback.trim()})(element);`
					)({ ancestor_matches, element, imp });
				}
			}
		};
		new MutationObserver((mutations) =>
			mutations.forEach((mutation) => {
				if (mutation.type === "childList") {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1 && node.hasAttribute(`data-${attribute}`)) {
							go(node);
						}
					});
				}
			})
		).observe(document.body, { childList: true, subtree: true });
		document.querySelectorAll(`*[data-${attribute}]`).forEach(go);
	};

	init_animations("animate");
})();
